<template>
    <div class="MhomePage">
        <mt-swipe class="swipe" :show-indicators="false">
            <mt-swipe-item v-for="item in bannerList" :key="item.bannerIndex">
                <img @click="Jump(item.path)" class="banner" :src="item.url" alt="">
            </mt-swipe-item>
        </mt-swipe>
        <div class="product">
            <h2>解决产品</h2>
            <div class="product">
                <div class="single" v-for="(list,i) in productList" :key="i">
                    <h3>{{list.title}}</h3>
                    <img :src="list.iconPath" alt="">
                    <p>{{list.contentT}}</p>
                    <p>{{list.contentB}}</p>
                    <div v-if="list.id != 8" class="view" @click="jumpProduct(list.id,list.parall)">
                        查看详情
                    </div>
                    <div v-else class="view" style="opacity: 0">
                        查看详情
                    </div>
                </div>
            </div>

            <h2>顾问招揽</h2>
            <div class="solicit" @click="Jump('/MaddAdvisers')">
                <p>
                    互联智能，推动劳力服务向知识服务转移，专业人员迎来了自由流动的创作的时代。
                    用户得不到响应时代变化的价值服务，从者人员收入和地位得不到提升。橙蟹为之而生。
                </p>
                <div>
                    <img src="../../assets/img/home－image－3.png" alt="">
                </div>
            </div>

            <h2 class="ifon">企业资讯<a class="more" @click="Jump('/MaboutUs/3')">查看更多></a></h2>
            <mt-swipe class="yyswipe" :show-indicators="false">
                <mt-swipe-item v-for="item in informationList" :key="item.companyNewsId">
                    <div class="yyswipeBox" @click="Jump('/McompanyNewsDetail/' + item.companyNewsId)">
                        <img :src="url+item.companyNewsImg" alt="">
                        <h4>{{item.title}}</h4>
                        <p>{{item.description}}</p>
                    </div>
                </mt-swipe-item>
            </mt-swipe>

            <h2 class="gw">体验财务顾问</h2>
            <div class="form">
                <mt-field label="用户姓名" placeholder="请输入您的名字" v-model="form.name"></mt-field>
                <mt-field label="公司名称" placeholder="请输入公司名称" v-model="form.companyName"></mt-field>
                <mt-field label="联系电话" placeholder="请输入联系电话" type="tel" v-model="form.mobile"></mt-field>
                <mt-field label="咨询问题" placeholder="请输入咨询问题" type="textarea" rows="4" v-model="form.content"></mt-field>
                <mt-button class="button" type="danger" @click="onSubmit">完成并发送</mt-button>
            </div>
        </div>

    </div>
</template>

<script>
    import { companyNews, addConsultant } from '../../api/api.js'
    import { Toast } from 'mint-ui';
    export default {
        name: 'MhomePage',
        created() {
            companyNews().then((res) => {
                for (let i = 0; i < res.data.data.list.length; i++) {
                    if (this.informationList.length < 4 && res.data.data.list[i].companyNewsStatus == '1') {
                        this.informationList.push(res.data.data.list[i])
                    }
                }
            })
        },
        data() {
            return {
                url: this.GLOBAL.picURL,
                informationList: [],
                bannerList: [
                {
                    url: require("../../assets/img/Mbanner1.jpg"),
                    bannerIndex: "1",
                    path: '/MaboutUs/1'
                },
                {
                    url: require("../../assets/img/Mbanner2.jpg"),
                    bannerIndex: "2",
                    path: '/Mproduct'
                },
                {
                    url: require("../../assets/img/Mbanner3.jpg"),
                    bannerIndex: "3",
                    path: '/MaddAdvisers'
                }],
                productList: [
                {
                    title: "财务核算",
                    contentT: "独立",
                    contentB: "有专业范",
                    iconPath: require("../../assets/img/product1.png"),
                    id: 1,
                    parall: 'cwhs'
                },
                {
                    title: "财务预算",
                    contentT: "不止做到，还要做好",
                    contentB: "基于财务的运作模式预测",
                    iconPath: require("../../assets/img/product2.png"),
                    id: 2,
                    parall: 'cwys'
                },
                {
                    title: "财务猎人",
                    contentT: "财务人员推荐服务",
                    contentB: "为企业猎聘财务人才",
                    iconPath: require("../../assets/img/product3.png"),
                    id: 3,
                    parall: 'cwlr'
                },
                {
                    title: "税务筹划",
                    contentT: "适配高收入人群的",
                    contentB: "节税产品",
                    iconPath: require("../../assets/img/product4.png"),
                    id: 4,
                    parall: 'swch'
                },
                {
                    title: "股权激励",
                    contentT: "解决财务烦恼",
                    contentB: "专业的事情就让我们来做",
                    iconPath: require("../../assets/img/product5.png"),
                    id: 5,
                    parall: 'gqjl'
                },
                {
                    title: "年中复盘",
                    contentT: "为客户提升财务",
                    contentB: "管理效率",
                    iconPath: require("../../assets/img/product6.png"),
                    id: 6,
                    parall: 'lzfp'
                },
                {
                    title: "年终复盘",
                    contentT: "透过历史问题",
                    contentB: "解决未来难题",
                    iconPath: require("../../assets/img/product7.png"),
                    id: 7,
                    parall: 'nzfp'
                },
                {
                    title: "创新财务",
                    contentT: "产品持续更新中",
                    contentB: "敬请期待",
                    iconPath: require("../../assets/img/product8.png"),
                    id: 8,
                    parall: 'cxcw'
                }],
                form: {
                    name: '',
                    companyName: '',
                    emianl: '',
                    mobile: '',
                    content: '',
                },
            }
        },
        methods: {
            Jump(key) {
                this.$router.push({ path: key });
            },
            jumpProduct(id, parall) {
                this.$router.push({ path: '/Mproduct#' + parall, query: { id: id } });
            },
            onSubmit() {
                addConsultant(this.form).then((res) => {
                    if (res.status === 1) {
                        Toast({
                            message: '操作成功',
                            iconClass: 'icon icon-success'
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>
    /* banner */
    .swipe {
        height: 24.285714rem;

        /* height: 242px; */
    }

    .swipe .banner {
        width: 100%;
        height: 100%;
    }

    /* 解决产品 */
    h2 {
        text-align: center;
        color: #2e324f;
        padding: 4% 0;
        font-size: 18px;
    }

    .product {
        background-color: #f5f5f5;
    }

    .single {
        display: inline-block;
        width: 40%;
        margin: 1% 1%;
        padding: 6% 4%;
        text-align: center;
        background-color: #ffffff;
        font-size: 12px;
    }

    .single .view {
        color: #0067b8
    }

    /* 顾问招募 */
    .solicit {
        padding: 1% 6%;
        background-color: #ffffff;
    }

    .solicit p {
        padding-bottom: 4%;
        font-size: 14px;
        text-indent: 28px;
    }

    .solicit img {
        width: 100%;
    }

    /* 企业资讯 */
    .ifon {
        position: relative;
    }

    .more {
        font-size: 12px;
        position: absolute;
        padding-right: 3%;
        padding-top: 1%;
        right: 0;
    }

    .yyswipe {
        width: 100%;
        height: 52.285714rem;
        /* height: 366px; */
        padding-bottom: 4%;
    }

    .yyswipeBox {
        width: 100%;
        height: 100%;
    }

    .yyswipeBox img {
        width: 100%;
        height: 60%;
    }

    .yyswipeBox h4 {
        color: #2e324f;
        font-size: 16px;
        padding: 1% 2%;
    }

    .yyswipeBox p {
        padding: 1% 2%;
    }

    .form {
        text-align: center
    }

    .form .button {
        background-color: #585b72;
        width: 100%;
        padding: 2% 4%;
        margin: 2% 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/mobile/MhomePage.vue